import React, { useState } from 'react';
import { 
  CheckCircleIcon, 
  ClipboardDocumentIcon, 
  XMarkIcon,
  CheckIcon
} from '@heroicons/react/24/outline';

const PasswordSuccessModal = ({ agent, password, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircleIcon className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">הסיסמה אופסה בהצלחה!</h3>
              <p className="text-sm text-gray-500">
                {agent?.user?.first_name} {agent?.user?.last_name}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="bg-yellow-50 border-r-4 border-yellow-400 p-4 rounded">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="mr-3">
                <p className="text-sm text-yellow-800 font-medium">
                  חשוב! הסיסמה תוצג פעם אחת בלבד
                </p>
                <p className="text-sm text-yellow-700 mt-1">
                  הקפד להעתיק ולשמור את הסיסמה הזמנית לפני סגירת חלון זה
                </p>
              </div>
            </div>
          </div>

          {/* Password Display */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              סיסמה זמנית
            </label>
            <div className="relative">
              <div className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-lg font-mono text-lg text-center select-all">
                {password}
              </div>
              <button
                onClick={handleCopy}
                className={`absolute left-2 top-1/2 transform -translate-y-1/2 flex items-center gap-2 px-3 py-1.5 rounded-md transition-all ${
                  copied 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
                }`}
              >
                {copied ? (
                  <>
                    <CheckIcon className="h-4 w-4" />
                    <span className="text-sm font-medium">הועתק!</span>
                  </>
                ) : (
                  <>
                    <ClipboardDocumentIcon className="h-4 w-4" />
                    <span className="text-sm font-medium">העתק</span>
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="text-sm font-medium text-blue-900 mb-2">פרטי קשר של הסוכן:</h4>
            <div className="space-y-1 text-sm text-blue-800">
              <p><strong>אימייל:</strong> {agent?.user?.email}</p>
              {agent?.phone && (
                <p><strong>טלפון:</strong> {agent.phone}</p>
              )}
            </div>
          </div>

          {/* Instructions */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-900 mb-2">שלבים הבאים:</h4>
            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
              <li>העתק את הסיסמה הזמנית</li>
              <li>שלח אותה לסוכן באמצעי תקשורת מאובטח</li>
              <li>בקש מהסוכן לשנות את הסיסמה בהתחברות הראשונה</li>
            </ol>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-lg">
          <button
            onClick={onClose}
            className="w-full px-4 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium shadow-sm"
          >
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordSuccessModal;


